import { useState, useEffect } from   'react';
import { useParams, useNavigate} from 'react-router-dom';
import MenuEnlacesDX from './Componentes/MenuEnlacesDX';
import HeaderDXReloj from './Componentes/HeaderDXReloj';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';
import { useAuth } from '../../Auth/AuthContext';
import { useForm } from 'react-hook-form';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from './../../Auth/apiService';

export default function DXUbicacion() {
    const { iddx } = useParams();
    const { idrecepcion } = useParams();
    const Navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const [Cargando, setCargando] = useState(false);
    const [pendingResetData, setPendingResetData] = useState(null);
    const { token, user } = useAuth();
    const [estadoDx, setEstadoDx] = useState('');
    const [comunas, setComunas] = useState([]);
    const [barrios, setBarrios] = useState([]);
    const [fechaInicioAtencion, setFechaInicioAtencion] = useState(null);
    const { watch, handleSubmit, register, setValue, reset, control, formState: { errors }} = useForm({ 
            defaultValues: {
                iddx: '',
            } 
        }
    );
    const Mensaje = (title, text, icon) => {
        setSwalProps({
            show: true,
            title,
            text,
            icon, // 'success' or 'error'
        });
    };
    useEffect(() => {
        if (pendingResetData && comunas.length > 0) {
            FormReset(pendingResetData);
            setPendingResetData(null);
        }
    }, [pendingResetData, comunas]);
    useEffect(() => {
        const fethcData = async () => {
            const url = '/diagnostico/Crearformularioubicacion';
            const obj = {iddx: iddx }
            await apiService.post(url, obj, token)
            .then((response) => {
                setFechaInicioAtencion(response.data.recepcion.repFechahoraatencion);
                setEstadoDx(response.data.estadodx);
                if(response.data.comunas) {
                    setComunas(response.data.comunas);
                } else {
                    console.log('No hay comunas');
                    setComunas([]);
                }
                if(response.data.barrios) {
                    setBarrios(response.data.barrios);
                } else {
                    console.log('No hay barrios');
                    setBarrios([]);
                }
                if (response.data.ubicacion) {
                    setPendingResetData(response.data.ubicacion);
                } else {
                    
                    Mensaje('Error', response.data.message, 'error');
                }
            })
            .catch((error) => {
                setCargando(false);
                Mensaje('Error', 'Error al cargar los datos', 'error');
            })
            .finally(() => {
                setCargando(false);
            });
        }
        fethcData();
    }, [iddx, token]);
    const FormReset = (data) => {
        reset((prevValues) => ({
            ...prevValues,
            iddx: data?.iddx || '',
            ubi_3_1_comuna_o_corregimiento: data?.ubi_3_1_comuna_o_corregimiento || '',
            ubi_3_2_barrio_o_vereda: data?.ubi_3_2_barrio_o_vereda || '',
            ubi_3_3_asentamiento_o_sector: data?.ubi_3_3_asentamiento_o_sector || '',
            ubi_3_4_direccion: data?.ubi_3_4_direccion || '',
            ubi_3_4_1_observacion_direccion: data?.ubi_3_4_1_observacion_direccion || '',
            ubi_3_5_telefonos: data?.ubi_3_5_telefonos || '',
            ubi_3_5_2_telefono: data?.ubi_3_5_2_telefono || '',
            ubi_3_6_correoelectronico: data?.ubi_3_6_correoelectronico || '',
        }));
    };  
    function irAVictimizacion(){
        if(estadoDx >= 5)
        Navigate(`/dx/victimizacion/${iddx}/${idrecepcion}`);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/diagnostico/guardarubicacion';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                setEstadoDx(response.data.estadodx);
                Mensaje('Guardar', JSON.stringify(response.data.message), 'success');
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors), 'error');
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data), 'error');
            } else {
                Mensaje('Guardar', 'Error al guardar los datos', 'error');
                console.error('Error fetching data:', error);
            }
                
        } finally {
            setCargando(false);
        }
    };   
    return (
        
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Diagnostico base - Ubicación"
                idCabezaFamilia="1"
                url="/dx/diagnosticodx"
                nombreurl="Diagnostico dx"
                nombreform="Ubicación"
            />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <HeaderDXReloj startTime={fechaInicioAtencion} estadoDx={estadoDx} />
                <MenuEnlacesDX iddx={iddx} idrecepcion={idrecepcion} buttonActive={4} estadoDx={estadoDx}/>
                <div id="formDiagnostico" className="card">
                    
                    <div className="row">
                    <div className="col-md-12">
                        <div className="nav-tabs-custom">
                        <div className="tab-content">
                            <h4>3. UBICACI&oacute;N EN MEDELL&iacute;N</h4>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className='card'>
                                    <div className="card-body">
                                        <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor="slcubi_3_1_comuna_o_corregimiento">3.1. Comuna o Corregimiento</label>
                                            <select
                                                className="form-control"
                                                id="slcubi_3_1_comuna_o_corregimiento"
                                                style={{ width: "100%" }}
                                                {...register("ubi_3_1_comuna_o_corregimiento", { required: true })}
                                                disabled
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {comunas.map((comuna) => (
                                                    <option key={comuna.id} value={comuna.id}>
                                                        {comuna.comuna}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.ubi_3_1_comuna_o_corregimiento && (
                                                <span className="text-danger">Este campo es requerido</span>
                                            )}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='slcubi_3_2_barrio_o_vereda'>3.2. Barrio o Vereda</label>
                                            <select
                                                className="form-control"
                                                id="slcubi_3_2_barrio_o_vereda"
                                                style={{ width: "100%" }}
                                                {...register("ubi_3_2_barrio_o_vereda", { required: true })}
                                                onChange={(e) => {
                                                    setValue("ubi_3_1_comuna_o_corregimiento", 
                                                        comunas.find(
                                                            comuna => comuna.id === barrios.find(
                                                                b => b.id === e.target.value)
                                                                .idcomuna).id);
                                                    setValue("ubi_3_2_barrio_o_vereda", e.target.value);
                                                }}
                                                onBlur={(() => {
                                                    document.getElementById('infoslcubi_3_2_barrio_o_vereda').hidden = true;
                                                })}
                                                onFocus={(() => {
                                                    document.getElementById('infoslcubi_3_2_barrio_o_vereda').hidden = false;
                                                })}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {barrios.map((barrio) => (
                                                    <option key={barrio.id} value={barrio.id}>
                                                        {barrio.barrio}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.ubi_3_2_barrio_o_vereda && (
                                                <span className="text-danger">Este campo es requerido</span>
                                            )}
                                            <span hidden id="infoslcubi_3_2_barrio_o_vereda">Seleccionar el nombre del BARRIO en el que se ubica o vive actualmente el miembro del hogar.</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='txtubi_3_3_asentamiento_o_sector'>3.3. Asentamiento o Sector</label>
                                            <input
                                                id="txtubi_3_3_asentamiento_o_sector"
                                                maxLength="120"
                                                type="text"
                                                className="form-control"
                                                placeholder="Sector o Asentamiento"
                                                {...register("ubi_3_3_asentamiento_o_sector")}
                                                onBlur={(e) => {
                                                    e.target.value = e.target.value.toUpperCase();
                                                    document.getElementById('infotxtubi_3_3_asentamiento_o_sector').hidden = true;
                                                }}
                                                onFocus={() => {
                                                    document.getElementById('infotxtubi_3_3_asentamiento_o_sector').hidden = false;
                                                }}
                                            />
                                            <span hidden id="infotxtubi_3_3_asentamiento_o_sector">Indicar el nombre del SECTOR O ASENTAMIENTO en el que se ubica o vive actualmente el miembro del Hogar.</span>
                                            </div>  
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='txtubi_3_4_direccion'>3.4. Direccion lugar receptor</label>
                                            <input
                                                id="txtubi_3_4_direccion"
                                                maxLength="120"
                                                type="text"
                                                className="form-control"
                                                placeholder="Ej. CL 10 A SUR 35 25 APTO 305"
                                                {...register("ubi_3_4_direccion", { 
                                                    required: true,
                                                    validate: value => /^[a-zA-Z0-9\s]+$/.test(value) || "Solo letras y números permitidos"
                                                })}
                                                onBlur={(e) => {
                                                    e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s]/g, '').toUpperCase();
                                                    document.getElementById('infotxtubi_3_4_direccion').hidden = true;
                                                }}
                                                onFocus={() => {
                                                    document.getElementById('infotxtubi_3_4_direccion').hidden = false;
                                                }}
                                            />
                                            {errors.ubi_3_4_direccion && (
                                                <span className="text-danger">Este campo es requerido {errors.ubi_3_4_direccion?.message}</span>
                                            )}
                                            <span hidden id="infotxtubi_3_4_direccion">Es fundamental que se coloque alguna direccion.</span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='txtubi_3_4_1_observacion_direccion'>3.4.1. Observación Dirección</label>
                                            <input
                                                id="txtubi_3_4_1_observacion_direccion"
                                                maxLength="120"
                                                type="text"
                                                className="form-control"
                                                placeholder="Observación Dirección"
                                                {...register("ubi_3_4_1_observacion_direccion", { required: "Este campo es obligatorio" })}
                                                onBlur={(e) => {
                                                    e.target.value = e.target.value.toUpperCase();
                                                    document.getElementById('infotxttxtubi_3_4_1_observacion_direccion').hidden = true;
                                                }}
                                                onFocus={() => {
                                                    document.getElementById('infotxttxtubi_3_4_1_observacion_direccion').hidden = false;
                                                }}
                                            />
                                            {errors.ubi_3_4_1_observacion_direccion && (
                                                <span className="text-danger">Este campo es requerido {errors.ubi_3_4_1_observacion_direccion?.message}</span>
                                            )}
                                            <span hidden id="infotxttxtubi_3_4_1_observacion_direccion">Es fundamental que se coloque alguna observación sobre la dirección.</span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='txtubi_3_5_telefonos'>3.5.1. Tel&eacute;fono</label>
                                            <input
                                                id="txtubi_3_5_telefonos"
                                                maxLength="120"
                                                type="text"
                                                className="form-control"
                                                placeholder="Telefono"
                                                {...register("ubi_3_5_telefonos", { required: "Este campo es obligatorio" })}
                                                onBlur={(e) => {
                                                    e.target.value = e.target.value.toUpperCase();
                                                    document.getElementById('infotxtubi_3_5_telefonos').hidden = true;
                                                }}
                                                onFocus={() => {
                                                    document.getElementById('infotxtubi_3_5_telefonos').hidden = false;
                                                }}
                                            />
                                            {errors.ubi_3_5_telefonos && (
                                                <span className="text-danger">Este campo es requerido</span>
                                            )}
                                            <span hidden id="infotxtubi_3_5_telefonos">Digitar el numero telefonico fijo o celular. Es fundamental que se coloque algun numero de telefono o celular.</span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='txtubi_3_5_2_telefono'>3.5.2. Tel&eacute;fono</label>
                                            <input
                                                id="txtubi_3_5_2_telefono"
                                                maxLength="120"
                                                type="text"
                                                className="form-control"
                                                placeholder="Telefono"
                                                {...register("ubi_3_5_2_telefono")}
                                                onBlur={(e) => {
                                                    e.target.value = e.target.value.toUpperCase();
                                                    document.getElementById('infotxtubi_3_5_2_telefonos').hidden = true;
                                                }}
                                                onFocus={() => {
                                                    document.getElementById('infotxtubi_3_5_2_telefonos').hidden = false;
                                                }}
                                            />
                                            <span hidden id="infotxtubi_3_5_2_telefonos">Digitar el numero telefonico fijo o celular. Es fundamental que se coloque algun numero de telefono o celular.</span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='txtubi_3_6_correoelectronico'>3.6. Correo electr&oacute;nico</label>
                                            <input
                                                id="txtubi_3_6_correoelectronico"
                                                maxLength="120"
                                                type="text"
                                                className="form-control"
                                                placeholder="Correo"
                                                {...register("ubi_3_6_correoelectronico")}
                                                onBlur={(e) => {
                                                    document.getElementById('infotxtubi_3_6_correoelectronico').hidden = true;
                                                }}
                                                onFocus={() => {
                                                    document.getElementById('infotxtubi_3_6_correoelectronico').hidden = false;
                                                }}
                                            />
                                            <span hidden id="infotxtubi_3_6_correoelectronico">Digitar el correo electronico.</span>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <div className="row">
                                            <div className="col-md-6">
                                            <button id="btnDxActualizarUbicacion" type="submit" className="btn btn-block btn-primary btn-sm">Actualizar y seguir con Victimizaci&oacute;n
                                            </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        </div>
                    </div>
                    </div>    
                </div>     
                <SweetAlert2
                    {...swalProps}
                    didClose={() => setSwalProps({})}
                    onConfirm={() => {
                        if (swalProps.icon === 'success') {
                            setSwalProps({});
                            irAVictimizacion();
                        } else {
                            setSwalProps({});
                        }
                    }}
                />
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
        
    )
  }